export const ACTION_TYPE_GOOGLE = 'googleOAuthPermissions';
export const ACTION_TYPE_VERIFY_EMAIL = 'verifyEmail';

export const VENDOR_TYPE_GOOGLE = 'google';

export const TRIGGER_EMAIL_COLLECTION_PAYLOAD_NAME = 'triggerEmailCollectionPrompt';
